import { ApiTypes, SlackChannel } from '@mode/shared/contract-common';

interface OrgSettings {
  email_attachments_enabled: boolean;
  external_sharing: boolean;
}

interface HasOrgSettings {
  settings: Partial<OrgSettings>;
}

export interface OrgResource extends ApiTypes.ModeResource, HasOrgSettings {}

export interface RawScheduleOwner {
  authorized_domains: Array<string>;
  slackApp(): Promise<SlackApp>;
  token: string;
  _resource?: OrgResource;
}

export interface SlackApp {
  team_url: string;
  team_name: string;
  channels: () => Promise<Array<SlackChannel>>;
}

export abstract class ScheduleOwnerFacade {
  public abstract rawScheduleOwner: RawScheduleOwner;
  public abstract loadOwner(rawScheduleOwner: RawScheduleOwner): void;
  public abstract get authorizedDomains(): string[];
  public abstract get emailAttachmentsEnabled(): boolean | undefined;
  public abstract get orgToken(): string;
}
